module.exports = __webpack_public_path__ + "static/media/work-with-you.8586b6fe.png";